module.exports = __webpack_public_path__ + "img/Airbnb-Hybrid2-scaled.d97f5f40.jpg";